// src/views/ReporteRender/ReporteRender.jsx
// Entrada del Chrome sin pantalla del worker de análisis: con el token de un
// solo uso deja la sesión y la configuración del usuario que lanzó el
// análisis en este navegador aislado y abre el Dashboard en modo reporte.
import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { aplicarSnapshotLocal, obtenerContextoJob } from '../../utils/analisisJobs';
import { guardarTokenReporte, reportarEstado } from '../Dashboard/reporteAutomatico';

const ReporteRender = () => {
    const { jobId } = useParams();
    const location = useLocation();
    const [mensaje, setMensaje] = useState('Preparando el reporte…');

    useEffect(() => {
        const token = new URLSearchParams(location.search).get('t');
        (async () => {
            try {
                if (!token) throw new Error('Falta el token del reporte.');
                const ctx = await obtenerContextoJob(jobId, { token });
                aplicarSnapshotLocal(ctx.snapshot, { incluirSesion: true });
                if (!localStorage.getItem('userData')) {
                    localStorage.setItem('userData', JSON.stringify({ userId: ctx.idUsuario }));
                }
                // La sesión de este Chrome solo sirve para dibujar el análisis.
                localStorage.setItem('Token', `reporte-${jobId}`);
                guardarTokenReporte(jobId, token);
                reportarEstado('cargando', { mensaje: 'Abriendo el Dashboard' });
                window.location.replace(`/mapeo?analisisJob=${jobId}&reporte=1`);
            } catch (error) {
                const texto = error?.response?.data?.message || error.message || 'No se pudo preparar el reporte.';
                setMensaje(texto);
                reportarEstado('error', { mensaje: texto });
            }
        })();
    }, [jobId, location.search]);

    return <div style={{ padding: 24, fontFamily: 'sans-serif' }}>{mensaje}</div>;
};

export default ReporteRender;
